import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const UnorderedList = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 9C6.10457 9 7 8.10457 7 7C7 5.89543 6.10457 5 5 5C3.89543 5 3 5.89543 3 7C3 8.10457 3.89543 9 5 9ZM11 6C10.4477 6 10 6.44772 10 7C10 7.55228 10.4477 8 11 8H28C28.5523 8 29 7.55228 29 7C29 6.44772 28.5523 6 28 6H11ZM11 15C10.4477 15 10 15.4477 10 16C10 16.5523 10.4477 17 11 17H28C28.5523 17 29 16.5523 29 16C29 15.4477 28.5523 15 28 15H11ZM10 25C10 24.4477 10.4477 24 11 24H28C28.5523 24 29 24.4477 29 25C29 25.5523 28.5523 26 28 26H11C10.4477 26 10 25.5523 10 25ZM7 16C7 17.1046 6.10457 18 5 18C3.89543 18 3 17.1046 3 16C3 14.8954 3.89543 14 5 14C6.10457 14 7 14.8954 7 16ZM5 27C6.10457 27 7 26.1046 7 25C7 23.8954 6.10457 23 5 23C3.89543 23 3 23.8954 3 25C3 26.1046 3.89543 27 5 27Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default UnorderedList
